/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * UPDATED FOR PAX A77 TERMINAL COMPATIBILITY:
 * - Android 8.1 with embedded WebView (version 55-70)
 * - 1GB RAM - needs lightweight polyfills
 * - No System WebView app - frozen WebView version
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * CRITICAL: globalThis polyfill - MUST be first!
 * Chrome 70 doesn't support globalThis (added in Chrome 71)
 * PAX A77 has WebView 70, so we need this polyfill
 */
(function() {
  if (typeof globalThis === 'undefined') {
    (window as any).globalThis = window;
  }
})();

/***************************************************************************************************
 * BROWSER POLYFILLS - PAX A77 COMPATIBILITY
 */

/**
 * Core-js polyfills - disabled with ES2022 target (not needed for modern browsers)
 * Were previously used for PAX A77 terminal with older embedded WebView
 */
// import 'core-js/es/global-this';
// import 'core-js/es/symbol';
// import 'core-js/es/object';
// import 'core-js/es/function';
// import 'core-js/es/parse-int';
// import 'core-js/es/parse-float';
// import 'core-js/es/number';
// import 'core-js/es/math';
// import 'core-js/es/string';
// import 'core-js/es/date';
// import 'core-js/es/array';
// import 'core-js/es/regexp';
// import 'core-js/es/map';
// import 'core-js/es/weak-map';
// import 'core-js/es/set';
// import 'core-js/es/promise';
// import 'core-js/es/reflect';

/**
 * Web Animations API polyfill (for Angular animations on older browsers)
 */
// import 'web-animations-js'; // Uncomment if animations don't work

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags.ts';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS flags - MUST be imported before zone.js
 * Fixes passive event listener errors on PAX A77
 */
import './zone-flags';

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.


/***************************************************************************************************
 * APPLICATION IMPORTS
 */
